import { render, staticRenderFns } from "./RequirementPool.vue?vue&type=template&id=6fa97572&scoped=true"
import script from "./RequirementPool.vue?vue&type=script&lang=js"
export * from "./RequirementPool.vue?vue&type=script&lang=js"
import style0 from "./RequirementPool.vue?vue&type=style&index=0&id=6fa97572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa97572",
  null
  
)

export default component.exports